export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.admin.sys_users': '用户管理',
  'menu.admin.sys_roles': '角色管理',
  'menu.admin.sys_permissions': '权限管理',
  'menu.admin.sys_settings': '系统设置',
  'menu.admin.prj_projects': '项目管理',
  'menu.sys_users': '用户管理',
  'menu.sys_roles': '角色管理',
  'menu.sys_permissions': '权限管理',
  'menu.sys_settings': '系统设置',
  'menu.prj_projects': '项目管理',
  'menu.prj_contracts': '合同管理',
  'menu.项目模块': '项目模块',
  'menu.项目模块.项目管理': '项目管理',
  'menu.项目模块.合同管理': '合同管理',
  'menu.项目模块.工人管理': '工人管理',
  'menu.项目模块.派工登记': '派工登记',
  'menu.项目模块.收款登记': '收款登记',
  'menu.项目模块.发票登记': '发票登记',
  'menu.项目模块.费用登记': '费用登记',
  'menu.项目模块.完工登记': '完工登记',
  'menu.项目模块.结项登记': '结项登记',
  'menu.项目模块.收货登记': '收货登记',
  'menu.库存模块': '库存模块',
  'menu.库存模块.SKU分类': 'SKU分类',
  'menu.库存模块.SKU': 'SKU',
  'menu.库存模块.仓库管理': '仓库管理',
  'menu.库存模块.入库单管理': '入库单管理',
  'menu.库存模块.出库单管理': '出库单管理',
  'menu.采购模块': '采购模块',
  'menu.采购模块.供应商列表': '供应商列表',
  'menu.采购模块.采购订单': '采购订单',
  'menu.系统管理': '系统管理',
  'menu.系统管理.用户管理': '用户管理',
  'menu.系统管理.角色管理': '角色管理',
  'menu.系统管理.权限管理': '权限管理',
  'menu.系统管理.系统设置': '系统设置',
  'menu.系统管理.项目类别': '项目类别',
  'menu.系统管理.项目施工类别': '项目施工类别',
  'menu.系统管理.项目类别施工类别配置': '项目类别施工类别配置',
  'menu.系统管理.发票类别': '发票类别',
  'menu.系统管理.费用类别': '费用类别',
  'menu.示例': '示例',
  'menu.示例.dashboard': 'Dashboard',
  'menu.示例.dashboard.analysis': '分析页',
  'menu.示例.dashboard.monitor': '监控页',
  'menu.示例.dashboard.workplace': '工作台',
  'menu.示例.form': '表单页',
  'menu.示例.form.basic-form': '基础表单',
  'menu.示例.form.step-form': '分步表单',
  'menu.示例.form.step-form.info': '分步表单（填写转账信息）',
  'menu.示例.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.示例.form.step-form.result': '分步表单（完成）',
  'menu.示例.form.advanced-form': '高级表单',
  'menu.示例.list': '列表页',
  'menu.示例.list.table-list': '查询表格',
  'menu.示例.list.basic-list': '标准列表',
  'menu.示例.list.card-list': '卡片列表',
  'menu.示例.list.search-list': '搜索列表',
  'menu.示例.list.search-list.articles': '搜索列表（文章）',
  'menu.示例.list.search-list.projects': '搜索列表（项目）',
  'menu.示例.list.search-list.applications': '搜索列表（应用）',
  'menu.示例.profile': '详情页',
  'menu.示例.profile.basic': '基础详情页',
  'menu.示例.profile.advanced': '高级详情页',
  'menu.示例.result': '结果页',
  'menu.示例.result.success': '成功页',
  'menu.示例.result.fail': '失败页',
  'menu.示例.exception': '异常页',
  'menu.示例.exception.403': '403',
  'menu.示例.exception.404': '404',
  'menu.示例.exception.500': '500',
  'menu.示例.account': '个人页',
  'menu.示例.account.center': '个人中心',
  'menu.示例.account.settings': '个人设置',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.用户中心': '用户中心',
  'menu.用户中心.用户设置': '用户设置',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
